// extracted by mini-css-extract-plugin
module.exports = {"root":"falling-gifts_root__YO5up","gift":"falling-gifts_gift__ShWke","fallAndRotate":"falling-gifts_fallAndRotate__83rwx"};